import * as paths from "../constants/paths";

/**
 * Global property-type counts for the search filter panel.
 *
 * This is deliberately a bare `fetch` GET rather than one of the axios clients,
 * for three reasons:
 *
 *  1. CloudFront only caches HEAD and GET. The axios call sites used POST, so the
 *     edge could never hold this response no matter what the origin sent.
 *  2. The axios clients attach `Authorization` and `Content-type: application/json`,
 *     either of which turns this into a preflighted CORS request — an extra round
 *     trip before the real one. The endpoint requires no authentication at all.
 *  3. `credentials: "omit"` keeps cookies off the request. The distribution's cache
 *     policy keys on all cookies, so sending them would fragment the edge cache
 *     per-viewer and largely defeat the point.
 *
 * Same shape as the autocomplete hook, for the same reasons.
 */
export async function fetchFilterCounts(signal) {
  const url = new URL("getFilterCounts", paths.API_OPENSEARCH_URL);

  const response = await fetch(url.toString(), {
    credentials: "omit",
    signal,
  });

  if (!response.ok) {
    throw new Error(`getFilterCounts request failed with ${response.status}`);
  }

  const data = await response.json();
  return data?.counts ?? null;
}
